import type { GasViscosityCalculator } from "../d";

export const leeGasViscosityCalculator: GasViscosityCalculator = params => {
  const { temperatureInRankine, gasMolecularWeight, gasDensityLBMFT3 } = params;

  // N47: =((9.4+0.02*D33)*D27^1.5)/(209+19*D33+D27)
  const K =
    ((9.4 + 0.02 * gasMolecularWeight) * temperatureInRankine ** 1.5) /
    (209 + 19 * gasMolecularWeight + temperatureInRankine);

  // N49: =3.5+986/D27+0.001*D33
  const X = 3.5 + 986 / temperatureInRankine + 0.001 * gasMolecularWeight;

  // N51: =2.4-0.2*N49
  const Y = 2.4 - 0.2 * X;

  // N53: =M22/62.428
  const gasDensityGCM3 = gasDensityLBMFT3 / 62.428;

  // N55: =(N47*EXP(N49*N53^N51))/10000
  const gasViscosityCP = (K * Math.exp(X * gasDensityGCM3 ** Y)) / 10000 || 0;

  return {
    gasViscosityCP,
    intermediates: {
      K,
      X,
      Y,
      gasDensityLBMFT3,
      gasDensityGCM3
    }
  };
};
